import { __read } from "tslib";
import { mergeClasses } from '@fluentui/react-components';
import { Checkmark20Regular, ChevronLeft20Regular, ChevronRight20Regular, } from '@fluentui/react-icons';
import React from 'react';
import { useFirstRunNavButtonStyles } from './FirstRunNavButton.styles';
var FirstRunNavButton = React.forwardRef(function (_a, ref) {
    var id = _a.id, config = _a.config, action = _a.action, clickAction = _a.clickAction, hidden = _a.hidden;
    var isRtl = document.dir === 'rtl';
    var _b = __read(React.useState(''), 2), ariaLabel = _b[0], setAriaLabel = _b[1];
    React.useEffect(function () {
        var _a = config.ariaLabels, backButtonAriaLabel = _a.backButtonAriaLabel, nextButtonAriaLabel = _a.nextButtonAriaLabel, completeExperienceButtonAriaLabel = _a.completeExperienceButtonAriaLabel;
        switch (action) {
            case 'back':
                setAriaLabel(backButtonAriaLabel);
                break;
            case 'next':
                setAriaLabel(nextButtonAriaLabel);
                break;
            case 'complete':
                setAriaLabel(completeExperienceButtonAriaLabel);
                break;
            default:
                var exhaustiveCheck = action;
                throw new Error(exhaustiveCheck);
        }
    }, [action, config]);
    var styles = useFirstRunNavButtonStyles();
    var containerStyles = React.useMemo(function () {
        return mergeClasses(styles.container, hidden && styles.hidden, action === 'back' && styles.positionLeft, (action === 'next' || action === 'complete') &&
            styles.positionRight);
    }, [
        styles.container,
        styles.hidden,
        styles.positionLeft,
        styles.positionRight,
        action,
        hidden,
    ]);
    var getIcon = React.useCallback(function () {
        switch (action) {
            case 'back':
                return isRtl ? (React.createElement(ChevronRight20Regular, null)) : (React.createElement(ChevronLeft20Regular, null));
            case 'next':
                return isRtl ? (React.createElement(ChevronLeft20Regular, null)) : (React.createElement(ChevronRight20Regular, null));
            case 'complete':
                return React.createElement(Checkmark20Regular, null);
            default:
                var exhaustiveCheck = action;
                throw new Error(exhaustiveCheck);
        }
    }, [action, isRtl]);
    var navButtonElement = React.useMemo(function () {
        return (React.createElement("button", { id: id, className: containerStyles, onClick: clickAction, title: ariaLabel, "aria-label": ariaLabel, ref: ref, tabIndex: hidden ? -1 : 0, "aria-hidden": hidden },
            React.createElement("div", { className: styles.background },
                React.createElement("div", { className: styles.arrowIcon }, getIcon()))));
    }, [
        id,
        containerStyles,
        clickAction,
        ariaLabel,
        ref,
        hidden,
        styles,
        getIcon,
    ]);
    return navButtonElement;
});
FirstRunNavButton.displayName = 'FirstRunNavButton';
export { FirstRunNavButton };
//# sourceMappingURL=FirstRunNavButton.js.map